import Core from '../../Core/Core';
import { DDNAEvents } from '../../DeltaTracking/Tracker';
import { Tracking } from './Tracking';

export enum BotTrackStages {
    ACCEPT = 'accept',
    CONFIRM = 'confirm',
    DENY = 'deny',
    SHOW = 'show',
    CLOSE = 'close',
}

export default class BotTracking {
    public static track(stage: BotTrackStages) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Bot_${stage}`,
        });

        if (stage !== BotTrackStages.ACCEPT && stage !== BotTrackStages.SHOW && Core.delta) {
            Core.delta.addTrackedEvent(
                DDNAEvents.BOT_OPTIONS_CHANGED,
                stage === BotTrackStages.CONFIRM
            );
        }
    }
}
